import React, { useState } from "react";
import "./Register.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { authHeaders } from "../utils/authHeaders";

function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export default function Register() {
  const [isPartner, setIsPartner] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    desa: "",
    kecamatan: "",
    kabupaten: "",
    provinsi: "",
    institution: "",
    role: "user",
    partner_id: ""
  });

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirm_password) {
      alert("Konfirmasi password tidak cocok.");
      return;
    }

    try {
      const payload = {
        full_name: formData.full_name,
        phone: formData.phone,
        email: formData.email,
        password_hash: formData.password,
        desa: formData.desa,
        kecamatan: formData.kecamatan,
        kabupaten: formData.kabupaten,
        provinsi: formData.provinsi,
        institution: formData.institution,
        role: formData.role,
        is_partner: isPartner ? 1 : 0,
        partner_id: isPartner ? formData.partner_id : null
      };

      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await fetch(`${apiUrl}/users/register`, {
        method: "POST",
        headers: authHeaders(getStoredUser(), { "Content-Type": "application/json" }),
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.success) {
        alert("Registrasi berhasil!");
        navigate("/dashboard");
      } else {
        alert("Registrasi gagal: " + (result.message || "Terjadi kesalahan."));
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Terjadi kesalahan pada saat registrasi.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Lengkapi Informasi Registrasi</h2>
        <form className="auth-form" onSubmit={handleRegister}>
          <div className="form-grid">
            <input type="text" placeholder="Nama Lengkap" required value={formData.full_name}
              onChange={(e) => setFormData({ ...formData, full_name: e.target.value })} />
            <input type="text" placeholder="No Handphone" required value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
            <input type="email" placeholder="Email" required value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
            <input type="text" placeholder="Desa" value={formData.desa}
              onChange={(e) => setFormData({ ...formData, desa: e.target.value })} />
            <input type="text" placeholder="Kecamatan" value={formData.kecamatan}
              onChange={(e) => setFormData({ ...formData, kecamatan: e.target.value })} />
            <input type="text" placeholder="Kabupaten" value={formData.kabupaten}
              onChange={(e) => setFormData({ ...formData, kabupaten: e.target.value })} />
            <input type="text" placeholder="Provinsi" value={formData.provinsi}
              onChange={(e) => setFormData({ ...formData, provinsi: e.target.value })} />
            <input type="text" placeholder="Institusi" value={formData.institution}
              onChange={(e) => setFormData({ ...formData, institution: e.target.value })} />
            <select value={formData.role} onChange={(e) => setFormData({ ...formData, role: e.target.value })}>
              <option value="user">User</option>
              <option value="mitra sahabat kakao">Mitra Sahabat Kakao</option>
              <option value="sahabat kakao">Sahabat Kakao</option>
              <option value="field team">Field Team</option>
              <option value="management">Management</option>
              <option value="admin">Admin</option>
            </select>

            {isPartner && (
              <input type="text" placeholder="Partner ID" required value={formData.partner_id}
                onChange={(e) => setFormData({ ...formData, partner_id: e.target.value })} />
            )}

            <div className="full-width checkbox">
              <label>
                <input type="checkbox" checked={isPartner}
                  onChange={() => setIsPartner(!isPartner)} />
                Apakah Anda Partner Sahabat Kakao?
              </label>
            </div>

            <div className="password-field">
              <input type={showPassword ? "text" : "password"} placeholder="Password" required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="password-field">
              <input type={showConfirm ? "text" : "password"} placeholder="Konfirmasi Password" required
                value={formData.confirm_password}
                onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })} />
              <span onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>
          <button type="submit" className="submit-btn">Daftar</button>
        </form>
      </div>
    </div>
  );
}
